'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateQuotes = exports.quoted = undefined;
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _constants = require('./constants');
var initialState = {
  fetching: false,
  requestError: false,
  quoteError: false,
  quoteRef: '',
  params: {
    age: '',
    postcode: '',
    licenceHeld: '',
    regNo: '',
    abiCode: '',
    value: '',
    discount: ''
  },
  quotes: []
};
var quoted = exports.quoted = function quoted(data) {
  return data.status === 'success';
};
var generateQuotes = exports.generateQuotes = function generateQuotes(data) {
  var coverLengths = [7, 14, 21, 28, 35, 42];
  return {
    quotes: coverLengths.map(function (day) {
      return {
        day: day.toString(),
        price: data['wasPremium' + day],
        discounted: data['premium' + day]
      };
    }),
    quoteRef: data.quoteId.toString()
  };
};
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          fetching: true,
          requestError: false,
          quoteError: false
        });
      }
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, initialState, {
          fetching: false,
          requestError: true
        });
      }
    case _constants.actionTypes.QUOTE + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        if (action.payload.data.status === 'SUCCESS' && quoted(action.payload.data.data)) {
          var data = action.payload.data.data;
          return Object.assign({
            fetching: false,
            requestError: false,
            quoteError: false,
            params: action.meta.params
          }, generateQuotes(data));
        }
        return Object.assign({}, state, {
          fetching: false,
          requestError: false,
          quoteError: true
        });
      }
    case _constants.actionTypes.CLEAR_QUOTES:
      {
        return initialState;
      }
    default:
      return state;
  }
};